import Swiper from 'swiper/bundle';

export default class Bnr {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const slideContainer = document.querySelector('.bnr__cont');
        const slideElements = slideContainer.querySelectorAll('.swiper-slide');

        if (slideElements.length <= 1) {
            // スライドが1枚以下の場合は特定のクラスを付与してスタイルを制御
            slideContainer.classList.add('-singleslide');
            return;
        }

        const option = {
            autoplay: { delay: 5000 },
            loop: true,
            pagination: { el: '.swiper-pagination', clickable: true },
        };

        new Swiper(slideContainer, option);
    }
}
